import axios from 'axios';

function errorHandler(error, reject) {
    if (error.response && error.response.data) {
        reject(error.response.data);
    } else {
        reject(error);
    }
}

export default {
    approval(formData) {
        return new Promise(async (resolve, reject) => {
            try {
                // console.log('File Name : ', formData.filename);
                const { data } = await axios.post("koraniklanorderrevision/send2wf", formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                });
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    approvalUndo(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const resp = await axios.put(`/koraniklanorderrevision/send2wfCancel/${obj.revisionkey}`);
                resolve(resp);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },
    list(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['page', 'limit', 'sortBy', 'sortDir', 'orderdate', 'orderno', 'customer_id', 'platform', 'tgl1', 'tgl2', 'pemasang', 'Advertiser', 'mediaorder', 'juduliklan', 'brand', 'salesae_id', 'salesae_name'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                const url = `/koraniklanorderrevision${str}`;
                const { data } = await axios.get(url);
                const { meta, list } = data;
                obj.total = meta.total;
                resolve(list);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },
    print(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                // console.log('obj : ', obj);
                const { data } = await axios.get(`/koraniklanorderrevision/print/${obj.revisionkey}`);
                const link = `${process.env.VUE_APP_BASE_API}/printpreview/pdf/${data.id}`
                resolve(link);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },
    save(data) {
        return new Promise(async (resolve, reject) => {
            try {
                const resp = await axios.post('/koraniklanorderrevision', data);
                resolve(resp);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },
    // update(obj) {
    //     return new Promise(async (resolve, reject) => {
    //         try {
    //             const resp = await axios.put(`/koraniklanorderrevision/${obj.key}`, obj.data);
    //             resolve(resp);
    //         } catch (error) {
    //             errorHandler(error, reject);
    //         }
    //     });
    // },
    remove(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const resp = await axios.delete(`/koraniklanorderrevision/${obj.revisionkey}`);
                resolve(resp);
            } catch (error) {
                errorHandler(error, reject);
            }
        })
    },
    detail(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                // console.log('obj : ', obj);
                const { data } = await axios.get(`/koraniklanorder/detail/${obj.orderid}`);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },
    detailRevisi(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                // console.log('obj : ', obj);
                const { data } = await axios.get(`/koraniklanorderrevision/detail/${obj.revisionkey}`);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },    
    exportxls(obj = {}) {
    return new Promise((resolve, reject) => {
        try {
            const keys = ['page', 'limit', 'sortBy', 'sortDir', 'orderdate', 'orderno', 'customer_id', 'platform', 'tgl1', 'tgl2', 'pemasang', 'Advertiser', 'mediaorder', 'juduliklan', 'brand', 'salesae_id', 'salesae_name'];
            let str = '';
            for (const key in obj) {
                if (keys.indexOf(key) >= 0 && obj[key]) {
                    str += str ? '&' : '?';
                    str += key + '=' + encodeURIComponent(obj[key]);
                }
            }
            axios({
                url: `/koraniklanorderrevision/exportxls${str}`,
                method: 'GET',
                responseType: 'blob', // important
            }).then((response) => {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', 'revisi_order_iklan_list.xlsx');
                document.body.appendChild(link);
                link.click();
                // window.location.assign(url);
                resolve(link);
            });

        } catch (error) {
            errorHandler(error, reject)
        }
    });
}    
};